<template>
	<div>
	<CreateMapEditor 
        :canDraw="canDraw" 
        :widthStyle="true" 
        :canEditPolygon="canEditPolygon"
        :canEditAndInteract="false"
        :detailsAreaPanelActive="false"
        :reviewAreaPanelActive="true"
    />
	<div id="createAreaReviewPanel" :class="{active: true}">
		<div class="panel--top">
			<h3>{{maContent.ma6_1}}</h3>
		</div>
		<div class="loading" v-if="areasLoading">loading areas...</div>
		<div v-if="savedAreas && areasLoading == false">
			<div class="panel areas">				
				 <div class="col md-12 area" v-for="(area, index) in savedAreas" v-bind:key="area">
					<div class="areas__count">{{index+1}}of{{savedAreas.length}}</div>
					<div class="del-btn__wrap">
						<button class="del-btn" @click="deleteArea(area.areaId)"></button>
					</div>
					<div class="area__title">{{area.areaTitle | truncate(80)}}</div>
					<div class="area__subtitle">{{maContent.ma6_2}} &nbsp;<span> {{area.areaSquared.toLocaleString('en')}} sqm</span></div>
					<table class="area__meta">
					<div class="area__subtitle"><span>Options selected:</span></div>											
					<div v-if="area.serviceOption1 === true"><div class="area__subtitle">{{maContent.ma6_3_1}}</div></div>
					<div v-if="area.serviceOption2 === true"><div class="area__subtitle">{{maContent.ma6_3_2}}</div></div>
					<div v-if="area.serviceOption3 === true"><div class="area__subtitle">{{maContent.ma6_3_3}}</div></div>
					<div v-if="area.serviceOption4 === true"><div class="area__subtitle">{{maContent.ma6_3_4}}</div></div>
					<div v-if="area.serviceOption5 === true"><div class="area__subtitle">{{maContent.ma6_3_5}}</div></div>
				
					<div class="area__subtitle"><span>Other details:</span></div>
					<div v-if="area.userUpload === false"><div class="area__subtitle">{{maContent.ma6_4_1}}</div></div>
					<div v-if="area.additionalDetails[0].length > 0"><div class="area__subtitle">{{maContent.ma6_5_1}}: <span>{{area.additionalDetails.join(", ")}}</span></div></div>

					</table>
				</div>

				
			<div class="panel__add-area">
				<button class="btn" @click="addAnotherArea">+&nbsp;&nbsp;{{maContent.ma6_6_1}}</button>
				</div>
			</div>
			
			<div class="panel panel__bottom">
				<div class="next-block-buttons">
					<div class="next-block__area-data col md-5">
						<div class="next-block__total-area-data">{{maContent.ma6_6_2}} - {{totalArea.toLocaleString('en')}} sqm</div>
						<div class="next-block__saved-areas">{{savedAreas.length}} {{maContent.ma6_6_3}}</div>
					</div>

					<div class="continue-area col md-7 ">
						<button class="btn primary" @click="goToSurveyQuoteSummary">Continue</button>
					</div>					
				</div>
			</div>
		</div>
		<div v-if="!savedAreas">
			Looks like you haven't got any saved areas.
		</div>
	</div>
	</div>
</template>

<script>
	import CreateMapEditor from '../common/Create/CreateMapEditor';
	export default {
		data(){
			return {
				canDraw : null,
            	canEditPolygon : false,
			
			}

		},
		components : {
			CreateMapEditor : CreateMapEditor
		},
		computed : {
			
			showAreaReviewPanel(){
				return this.$store.getters.showAreaReviewPanel
			},
			savedAreas(){
				return this.$store.getters.savedAreas;
			},
			areasLoading(){
				return this.$store.getters.areasLoading;
			},
			totalArea(){
				let areas = this.savedAreas

				if(areas.length == 0){
					return;
				}

				let reducedObj = areas.reduce(function (a, b) {
				 
				  return {areaSquared: a.areaSquared + b.areaSquared}; // returns object with property x
				})

				return reducedObj.areaSquared;
			},
			maContent(){
				return this.$store.getters.getBuildData;
				},


		},
		methods : {
			addAnotherArea(){
				return this.$store.commit('restartCreateAreaProcess')
			},
			deleteArea(areaId){
				return this.$store.dispatch('deleteArea', areaId)
				.then((response) => {
					console.log(response);
				})
				.catch((err) => {
					console.log(err);
				})
			},
			goToSurveyQuoteSummary(){
				return this.$store.dispatch('goToSurveyQuoteSummary')
			}
		},
		mounted(){

			// if(!this.savedAreas.length){
			// 	console.log(this.$router);
			// 	this.$router.push({path : '/create/select-area'})
			// }
		
		},

		created(){
		 this.$store.commit('closeModal', 'WelcomeModal');
	}

	}
</script>


// WEBPACK FOOTER //
// src/components/pages/CreateAreaReviewPanel.vue